import { makeStyles } from '@material-ui/core/styles';

import { startCase, toLower } from 'lodash';

import { Tag, TagGroup } from '@backstage/ui';

const SUCCESS_STATES = new Set([
  'active',
  'live',
  'completed',
  'allocated',
  'ok',
]);
const WARNING_STATES = new Set([
  'draft',
  'pending',
  'running',
  'unallocated',
  'in_review',
]);
const DANGER_STATES = new Set(['aborted', 'failed', 'error', 'rejected']);

const useStyles = makeStyles({
  danger: {
    background: 'var(--bui-bg-danger)',
    color: 'var(--bui-fg-danger)',
  },
  success: {
    background: 'var(--bui-bg-success)',
    color: 'var(--bui-fg-success)',
  },
  warning: {
    background: 'var(--bui-bg-warning)',
    color: 'var(--bui-fg-warning)',
  },
});

const normalizeState = (state: string) =>
  state.replace(/^STATE_/, '').toLowerCase();

const getColorClass = (
  state: string,
  classes: ReturnType<typeof useStyles>,
): string | undefined => {
  const normalized = normalizeState(state);
  if (SUCCESS_STATES.has(normalized)) return classes.success;
  if (WARNING_STATES.has(normalized)) return classes.warning;
  if (DANGER_STATES.has(normalized)) return classes.danger;
  return undefined;
};

interface StateTagProps {
  state: string;
}

export const StateTag = ({ state }: StateTagProps) => {
  const classes = useStyles();
  const label = startCase(toLower(state));
  return (
    <TagGroup aria-label={label}>
      <Tag
        id={state}
        textValue={label}
        size="small"
        className={getColorClass(state, classes)}
      >
        {label}
      </Tag>
    </TagGroup>
  );
};
